// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bec47eb2","455":"629df6bc","643":"9e5a8468","820":"03f40745"}[chunkId] + ".chunk.js";
};